(function () {
  'use strict';

  var initializedRoots = new WeakSet();
  var tooltipCount = 0;
  var activeController = null;

  function triggerFromEvent(root, target) {
    if (!target || typeof target.closest !== 'function') return null;
    var trigger = target.closest('[data-tooltip]');
    return trigger && trigger.closest('.bb-product') === root ? trigger : null;
  }

  function init(root) {
    if (!root || initializedRoots.has(root)) return;

    var tooltip = root.querySelector('[data-bb-tooltip]');
    if (tooltip && tooltip.closest('.bb-product') !== root) tooltip = null;
    if (!tooltip) {
      if (!root.querySelector('[data-tooltip]')) return;
      tooltip = document.createElement('div');
      tooltip.className = 'bb-field-tooltip';
      tooltip.setAttribute('data-bb-tooltip', '');
      root.appendChild(tooltip);
    }

    initializedRoots.add(root);
    tooltipCount += 1;

    if (!tooltip.id) tooltip.id = 'bb-product-tooltip-' + tooltipCount;
    tooltip.setAttribute('role', 'tooltip');
    tooltip.setAttribute('aria-hidden', 'true');

    var activeTrigger = null;
    var clickPinned = false;
    var controller = null;

    function titleFor(trigger) {
      if (trigger.dataset.tooltipTitle) return trigger.dataset.tooltipTitle;
      var field = trigger.closest('.bb-field');
      var label = field ? field.querySelector('.bb-field__label') : null;
      return label && label.textContent.trim() ? label.textContent.trim() : 'Helpful tip';
    }

    function render(trigger) {
      var title = document.createElement('div');
      title.className = 'bb-field-tooltip__title';
      title.textContent = titleFor(trigger);

      var body = document.createElement('div');
      body.className = 'bb-field-tooltip__body';
      body.textContent = trigger.dataset.tooltip || '';

      tooltip.replaceChildren(title, body);
    }

    function position(trigger) {
      tooltip.classList.remove('bb-field-tooltip--above');

      var margin = 10;
      var gap = 9;
      var triggerRect = trigger.getBoundingClientRect();
      var tooltipRect = tooltip.getBoundingClientRect();
      var maxLeft = Math.max(margin, window.innerWidth - tooltipRect.width - margin);
      var left = Math.max(
        margin,
        Math.min(
          triggerRect.left + (triggerRect.width / 2) - (tooltipRect.width / 2),
          maxLeft
        )
      );
      var belowTop = triggerRect.bottom + gap;
      var aboveTop = triggerRect.top - tooltipRect.height - gap;
      var showAbove = belowTop + tooltipRect.height > window.innerHeight - margin && aboveTop >= margin;
      var top = showAbove
        ? aboveTop
        : Math.min(belowTop, window.innerHeight - tooltipRect.height - margin);
      var arrowLeft = Math.max(
        16,
        Math.min(
          triggerRect.left + (triggerRect.width / 2) - left - 6,
          tooltipRect.width - 22
        )
      );

      tooltip.classList.toggle('bb-field-tooltip--above', showAbove);
      tooltip.style.left = left + 'px';
      tooltip.style.top = Math.max(margin, top) + 'px';
      tooltip.style.setProperty('--bb-tooltip-arrow-left', arrowLeft + 'px');
    }

    function hide() {
      if (activeTrigger) activeTrigger.removeAttribute('aria-describedby');
      tooltip.style.display = 'none';
      tooltip.setAttribute('aria-hidden', 'true');
      tooltip.classList.remove('bb-field-tooltip--above');
      activeTrigger = null;
      clickPinned = false;
      if (activeController === controller) activeController = null;
    }

    function show(trigger, pinToClick) {
      if (!trigger || !trigger.dataset.tooltip) return;
      if (activeTrigger && activeTrigger !== trigger) {
        activeTrigger.removeAttribute('aria-describedby');
      }
      if (activeController && activeController !== controller) {
        activeController.hide();
      }

      activeTrigger = trigger;
      clickPinned = Boolean(pinToClick);
      activeController = controller;
      render(trigger);
      trigger.setAttribute('aria-describedby', tooltip.id);
      tooltip.style.display = 'block';
      tooltip.setAttribute('aria-hidden', 'false');
      position(trigger);
    }

    controller = {
      root: root,
      hide: hide,
      getActiveTrigger: function () {
        return activeTrigger;
      },
      positionActive: function () {
        if (activeTrigger) position(activeTrigger);
      },
    };

    root.addEventListener('pointerover', function (event) {
      var trigger = triggerFromEvent(root, event.target);
      if (trigger && !clickPinned) show(trigger, false);
    });

    root.addEventListener('pointerout', function (event) {
      if (!activeTrigger || clickPinned) return;
      var trigger = triggerFromEvent(root, event.target);
      if (trigger !== activeTrigger) return;
      if (event.relatedTarget && activeTrigger.contains(event.relatedTarget)) return;
      hide();
    });

    root.addEventListener('focusin', function (event) {
      var trigger = triggerFromEvent(root, event.target);
      if (trigger && !clickPinned) show(trigger, false);
    });

    root.addEventListener('focusout', function (event) {
      var trigger = triggerFromEvent(root, event.target);
      if (trigger === activeTrigger && !clickPinned) hide();
    });

    root.addEventListener('click', function (event) {
      var trigger = triggerFromEvent(root, event.target);
      if (!trigger) {
        if (activeTrigger) hide();
        return;
      }
      if (trigger === activeTrigger && clickPinned) {
        hide();
        return;
      }
      show(trigger, true);
    });

  }

  function initAll(scope) {
    if (!scope) return;
    if (scope.matches && scope.matches('.bb-product')) init(scope);
    if (!scope.querySelectorAll) return;
    scope.querySelectorAll('.bb-product').forEach(init);
  }

  window.BadgeBuzzProductTooltip = {init: init};

  document.addEventListener('click', function (event) {
    if (!activeController || activeController.root.contains(event.target)) return;
    activeController.hide();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || !activeController) return;
    var trigger = activeController.getActiveTrigger();
    activeController.hide();
    if (trigger) trigger.focus();
  });

  window.addEventListener('scroll', function () {
    if (activeController) activeController.hide();
  }, {passive: true});

  window.addEventListener('resize', function () {
    if (activeController) activeController.positionActive();
  }, {passive: true});

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!activeController || !event.target) return;
    if (event.target === activeController.root || event.target.contains(activeController.root)) {
      activeController.hide();
    }
  });
})();
